import { render, staticRenderFns } from "./header-user.vue?vue&type=template&id=90d2c210&scoped=true&"
import script from "./header-user.vue?vue&type=script&lang=js&"
export * from "./header-user.vue?vue&type=script&lang=js&"
import style0 from "./header-user.vue?vue&type=style&index=0&id=90d2c210&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d2c210",
  null
  
)

export default component.exports